import script from "./birthday.vue?vue&type=script&setup=true&lang=js"
export * from "./birthday.vue?vue&type=script&setup=true&lang=js"

import "./birthday.vue?vue&type=style&index=0&id=668ae49e&lang=scss"

const __exports__ = script;

export default __exports__